export const getRandomAvatarColor = (name: string): string => {
  const colors = [
    'bg-pink-500', 'bg-indigo-500', 'bg-blue-500', 
    'bg-green-500', 'bg-purple-500', 'bg-orange-500', 
    'bg-red-500', 'bg-teal-500'
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

export const getUserInitials = (name: string): string => {
  if (!name) return "?";
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};
